import { render, staticRenderFns } from "./orderManagerCrm.vue?vue&type=template&id=5dac8824&scoped=true&"
import script from "./orderManagerCrm.vue?vue&type=script&lang=js&"
export * from "./orderManagerCrm.vue?vue&type=script&lang=js&"
import style0 from "./orderManagerCrm.vue?vue&type=style&index=0&id=5dac8824&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dac8824",
  null
  
)

export default component.exports